module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_rogaland_pos.0d939b02.png";